module.exports = __webpack_public_path__ + "img/4-8.03beb275.png";